(() => {
  const root = document.querySelector('[data-manual-library]');
  if (!root) return;

  const products = window.OnboardManualLibrary?.products || [];
  const search = root.querySelector('[data-manual-search]');
  const brand = root.querySelector('[data-manual-brand]');
  const type = root.querySelector('[data-manual-type]');
  const results = root.querySelector('[data-manual-results]');
  const summary = root.querySelector('[data-manual-summary]');
  const empty = root.querySelector('[data-manual-empty]');
  const more = root.querySelector('[data-manual-more]');
  const pageSize = 24;
  let visibleCount = pageSize;
  let filteredProducts = products;

  const documentLabels = {
    ownersManual: 'Owner’s manual',
    installationGuide: 'Installation guide',
    quickGuide: 'Quick guide',
    brochure: 'Brochure',
  };

  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  })[character]);

  const brands = [...new Set(products.map((product) => product.brand))].sort();
  brands.forEach((brandName) => {
    const option = document.createElement('option');
    option.value = brandName;
    option.textContent = brandName;
    brand.appendChild(option);
  });

  function renderProduct(product) {
    const documentLinks = Object.entries(product.docs)
      .filter(([documentType, url]) => url && (!type.value || type.value === documentType))
      .map(([documentType, url]) => `<a href="${escapeHtml(url)}" target="_blank" rel="noopener" class="manual-card__link">${documentLabels[documentType]}<span aria-hidden="true">↗</span></a>`)
      .join('');

    return `<article class="manual-card">
      <div class="manual-card__body">
        <div class="manual-card__brand">${escapeHtml(product.brand)}</div>
        <h2>${escapeHtml(product.title)}</h2>
        <dl><div><dt>Manufacturer part number</dt><dd>${escapeHtml(product.mpn)}</dd></div></dl>
      </div>
      <div class="manual-card__links">${documentLinks}</div>
    </article>`;
  }

  function update() {
    const query = search.value.trim().toLowerCase();
    const normalizedQuery = query.replace(/[^a-z0-9]/g, '').replace(/vic$/, '');
    filteredProducts = products.filter((product) => {
      const searchableText = `${product.title} ${product.mpn} ${product.sku} ${product.brand}`.toLowerCase();
      const normalizedSearchableText = searchableText.replace(/[^a-z0-9]/g, '');
      const matchesQuery = !query || searchableText.includes(query) || (normalizedQuery && normalizedSearchableText.includes(normalizedQuery));
      const matchesBrand = !brand.value || product.brand === brand.value;
      const matchesType = !type.value || Boolean(product.docs[type.value]);
      return matchesQuery && matchesBrand && matchesType;
    });

    results.innerHTML = filteredProducts.slice(0, visibleCount).map(renderProduct).join('');
    const shown = Math.min(visibleCount, filteredProducts.length);
    summary.textContent = filteredProducts.length === 1
      ? '1 product with manuals'
      : `${filteredProducts.length.toLocaleString()} products with manuals${filteredProducts.length > shown ? ` · showing ${shown}` : ''}`;
    empty.hidden = filteredProducts.length !== 0;
    more.hidden = shown >= filteredProducts.length;
  }

  [search, brand, type].forEach((control) => control.addEventListener('input', () => {
    visibleCount = pageSize;
    update();
  }));

  more.addEventListener('click', () => {
    visibleCount += pageSize;
    update();
  });

  update();
})();
